import { request } from '@/shared/api/request'

export const createContract = (data) => {
	return request({ url: 'contract/create', method: 'POST', data })
}
